"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

var _styledComponents = require("../../styledComponents");

var _jsxRuntime = require("react/jsx-runtime");

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var SaveActions = /*#__PURE__*/function (_Component) {
  _inherits(SaveActions, _Component);

  var _super = _createSuper(SaveActions);

  function SaveActions(props) {
    var _this;

    _classCallCheck(this, SaveActions);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "toggleActionsMenu", function (visible) {
      _this.setState({
        show: visible !== null && visible !== void 0 ? visible : !_this.state.show
      });
    });

    _defineProperty(_assertThisInitialized(_this), "hideActionsMenu", function () {
      return _this.toggleActionsMenu(false);
    });

    _defineProperty(_assertThisInitialized(_this), "handleSaving", function () {
      _this.props.handleSaveAs();

      _this.hideActionsMenu();
    });

    _this.state = {
      show: false
    };
    return _this;
  }

  _createClass(SaveActions, [{
    key: "render",
    value: function render() {
      var t = this.props.t;
      return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styledComponents.SaveActions, {
        children: [this.state.show && /*#__PURE__*/(0, _jsxRuntime.jsx)(_styledComponents.SaveActionsBackdrop, {
          onClick: this.hideActionsMenu
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styledComponents.SaveActionsSlideButton, {
          themeColor: true,
          onClick: this.toggleActionsMenu,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("i", {})
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styledComponents.SaveActionsMenu, {
          children: this.state.show && /*#__PURE__*/(0, _jsxRuntime.jsx)(_styledComponents.SaveActionsItem, {
            onClick: this.handleSaving,
            children: t['toolbar.saveAsNewImage']
          })
        })]
      });
    }
  }]);

  return SaveActions;
}(_react.Component);

exports.default = SaveActions;